import { frontendURL } from '../../../../helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions.js';
import AbratelPanelLayout from './Layout.vue';
import AbratelPanelIframe from './Index.vue';

const adminOnly = { permissions: [...ROLES] };

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/abratel'),
      component: AbratelPanelLayout,
      children: [
        {
          path: 'backup',
          name: 'abratel_backup',
          component: AbratelPanelIframe,
          meta: { ...adminOnly, panelFile: 'backup.html' },
        },
        {
          path: 'whatsapp-api',
          name: 'abratel_whatsapp_api',
          component: AbratelPanelIframe,
          meta: { ...adminOnly, panelFile: 'client.html' },
        },
        {
          path: 'csat',
          name: 'abratel_csat',
          component: AbratelPanelIframe,
          meta: { ...adminOnly, panelFile: 'csat.html' },
        },
      ],
    },
  ],
};
